import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ManagedProductsDashboard from './containers/ManagedProductsDashboard';
import ManagedProduct from './containers/ManagedProduct';
import CreateManagedProduct from './containers/CreateManagedProduct';

export default function ManagedProductsRoutes() {
  return (
    <Switch>
      <Route
        path="/w/:workspaceId/pm/products/new"
        component={CreateManagedProduct}
      />
      <Route
        path="/w/:workspaceId/pm/products/:productId"
        component={ManagedProduct}
      />
      <Route
        path="/w/:workspaceId/pm/products"
        component={ManagedProductsDashboard}
      />
    </Switch>
  );
}
